import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const requestGetMiscChargeById = (id) =>
    axios.get(`${apiUrl}miscCharges/${id}`);

export const requestInsertMiscChargeById = (data) =>
    axios.post(`${apiUrl}miscCharges`, data);

export const requestUpdateMiscChargeById = (id, data) =>
    axios.put(`${apiUrl}miscCharges/${id}`, data);

export const requestDeleteMiscChargeById = (id) =>
    axios.delete(`${apiUrl}miscCharges/${id}`);

export const requestGetMiscChargeTypes = (includeInactive) =>
    axios.get(`${apiUrl}miscChargeTypes?includeInactive=${includeInactive}`);

export const requestInsertMiscChargeType = (data) =>
    axios.post(`${apiUrl}miscChargeTypes`, data);

export const requestGetMiscChargeTypeById = (id) =>
    axios.get(`${apiUrl}miscChargeTypes/${id}`);

export const requestUpdateMiscChargeTypeById = (id, data) =>
    axios.put(`${apiUrl}miscChargeTypes/${id}`, data);

export const requestDeleteMiscChargeTypeById = (id) =>
    axios.delete(`${apiUrl}miscChargeTypes/${id}`);

export const requestGetMiscChargeRates = () =>
    axios.get(`${apiUrl}miscChargeRates`);

export const requestGetMiscChargeRatesSpecific = (employeeId, jobIdArr) =>
    axios.get(`${apiUrl}MiscCharges/rates?${jobIdArr.map(item => `jobIds=${item}`).join("&")}${employeeId && `&employeeId=${employeeId}`}`);

export const requestUpdateMiscChargeRates = (data) =>
    axios.put(`${apiUrl}miscChargeRates`, data);

export const requestMerchandisers = () =>
    axios.get(`${apiUrl}employees/merchandisers`);
